import{useRoute}from"./useRoute";import{getPageSettings}from"../config/getPageSettings";/**
 * Retrieves the settings for the current page.
 * See documentation of `getPageSettings` for further details.
 *
 * @param {string} [key=null] Optional key to read and inherit from theme settings
 * @returns {Object}
 */export function usePageSettings(){var key=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var _useRoute=useRoute(),pagePattern=_useRoute.pattern;return getPageSettings(pagePattern,key);}